import { ArrowRight, ShieldCheck, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Container } from "@/components/layout/container";

export function Hero() {
  return (
    <section id="beranda" className="relative overflow-hidden">
      <div
        aria-hidden
        className="pointer-events-none absolute -right-24 -top-32 h-96 w-96 rounded-full bg-accent/20 blur-3xl"
      />
      <Container className="flex flex-col items-center py-20 text-center sm:py-28">
        <span className="inline-flex items-center gap-2 rounded-full border border-border bg-surface-2 px-4 py-1.5 text-sm font-medium text-text-muted">
          <Sparkles className="h-4 w-4 text-accent" />
          Keamanan malam era baru, berbasis teknologi
        </span>

        <h1 className="mt-6 max-w-3xl text-4xl font-bold sm:text-6xl">
          Jaga Malam Anda dengan <span className="text-accent">Ronda Malam</span>
        </h1>

        <p className="mt-5 max-w-2xl text-lg text-text-muted">
          Pantau, laporkan, dan amankan lingkungan sekitar Anda secara real-time. Ronda Malam
          menghubungkan warga, petugas, dan teknologi dalam satu platform keamanan malam.
        </p>

        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <Button asChild size="lg">
            <a href="#kontak">
              Daftar Sekarang
              <ArrowRight className="h-4 w-4" />
            </a>
          </Button>
          <Button asChild size="lg" variant="outline">
            <a href="#fitur">Pelajari Fitur</a>
          </Button>
        </div>

        <div className="mt-10 flex items-center gap-2 text-sm text-text-muted">
          <ShieldCheck className="h-4 w-4 text-accent" />
          Terhubung langsung dengan layanan darurat &amp; petugas patroli
        </div>
      </Container>
    </section>
  );
}
